const data =  {
     products: [
       {
       id: 21,
       productName: 'Studio Bag',
       description: 'The Studio Bag is identical to its predecessor plus a few more inches to love. Transition it from satchel to backpack to crossbody simply by changing straps. Carry it wherever you go - it will be ready to adapt to your needs and keep up with your lifestyle.',
       image: 'https://i.ibb.co/PcXVJ8m/studiobag.jpg',
       price: 15,
       },
       {
       id: 22,
       productName: 'Cumulus',
       description: 'Light as air. The Cumulus is encased in cloud-like waterproof nylon and has a spacious main interior. Collapse it for easy travel and snap it shut with magnetic closures.',
       image: 'https://i.ibb.co/NtpJ0XQ/cumulus-olive.png',
       price: 28,
       },
       {
       id: 23,
       productName: 'Dance Bag Nylon',
       description: 'For days when you just need to grab and go. The Dance Bag is a compact, gumdrop-shaped backpack wrapped in water-repellent nylon. It’s the perfect carry-all for your life in motion.',
       image: 'https://i.ibb.co/yRKyXPJ/dance-nylon.png',
       price: 35,
       },
       {
       id: 24,
       productName: 'Stratus Backpack',
       description: 'The Stratus is encased in cloud-like waterproof nylon and features exterior + interior pockets for your water bottle, umbrella, and laptop. Reach around to the side for on-the-go access to the main compartment. Collapse it for easy travel. Your backpack just got an upgrade.',
       image: 'https://i.ibb.co/Br2W7F0/stratus-backpack.png',
       price: 30,
       },
       
       {
       id: 25,
       productName: 'Cirrus',
       description: 'The Cirrus rucksack is encased in cloud-like waterproof nylon and features ample interior and exterior pockets, including built-in phone + battery pockets to stay powered up on the go. Luggage slip and secure passport sleeve make it the perfect travel companion. Adventure away.',
       image: 'https://i.ibb.co/CPv6xTF/cirrus1.jpg',
       price: 65,
       },
       {
       id: 26,
       productName: 'Mini Circle',
       description: 'The Mini Circle is the ultimate multipurpose grab and go style. Transfer it from crossbody to waistbelt to wristlet simply by changing straps. Internal built-in battery that can charge your USB device. Vegan friendly.',
       image: 'https://i.ibb.co/LNNw217/mini-circle.png',
       price: 40,
       },
       {
       id: 27,
       productName: 'Studio Bag Vaqueta',
       description: 'You’re not any one thing, why should your bag be? The Studio Bag Vaqueta features everything you know and love about the Studio Bag wrapped up in colorful Italian nylon and exquisite vaqueta leather. ',
       image: 'https://i.ibb.co/QmGdpLf/studio-bag-vaqueta.jpg',
       price: 75,
       },
       {
       id: 28,
       productName: 'Sling',
       description: 'The Sling is encased in cloud-like waterproof nylon, features eight pockets, and can be worn as a waistbag or crossbody sling. Five colors, multiple carrying modes, all you. Vegan friendly + made for everyone.',
       image: 'https://i.ibb.co/LzyPnF3/sling.png',
       price: 25,
       },
     ]
   };
   
   export default data;